/**
 * Local modal footer (duplicated in-domain per CT-4175; do not import from
 * Governance). Right-aligned action row with a top divider.
 */
function ModalFooter({ children, className = '' }) {
  return (
    <div
      className={['flex items-center justify-end gap-2 border-t border-edge px-5 py-3', className]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}

export default ModalFooter;
